import styled from "styled-components";
import { COLORS, responsive } from "../../../styles/constants.style";

export const EditGenericAccountTabWrapper = styled.div`
  color: ${COLORS.cirrus_black};

  .container-bottom {
    ${responsive.MOBILE`
        padding: 0 8px 16px 8px;
        margin: 16px 0;
    `}
  }
`;
